import { IApplicationContext } from '../../types/applicationContext';
import { ResponseError } from '../../errors/ResponseError';
import { mapFavoriteDealType, mapFavoriteEntityType } from './mapFavoriteParameters';
import { TFavoriteServiceParameters } from './types';

type TDeleteFavoriteResponse =
  | {
      response: unknown;
      statusCode: 200;
    }
  | {
      response: {
        errors?: unknown;
        message?: string;
      };
      statusCode: number;
    };

function isDeleteFavoriteErrorResponse(
  response: TDeleteFavoriteResponse,
): response is { response: { errors?: unknown; message?: string }; statusCode: number } {
  return response.statusCode !== 200;
}

export async function deleteFromFavorite(
  { httpApi, logger }: IApplicationContext,
  { dealType, offerId, offerType }: TFavoriteServiceParameters,
): Promise<void> {
  try {
    const response = (await httpApi.fetch({
      v: 1,
      apiType: 'public',
      method: 'POST',
      microserviceName: 'favorites',
      pathApi: '/v1/delete-offer-from-favorites/',
      request: {
        contentType: 'json',
        parameters: {
          dealType: mapFavoriteDealType(dealType),
          entityId: offerId,
          entityType: mapFavoriteEntityType(offerType),
          forceRemoveFromFolders: true,
        },
      },
      response: {
        200: {
          contentType: 'json',
        },
        400: {
          contentType: 'json',
        },
      },
    })) as TDeleteFavoriteResponse;

    if (isDeleteFavoriteErrorResponse(response)) {
      throw new ResponseError({
        domain: 'deleteFromFavorite',
        message: response.response.message || 'Код ответа не 200',
        details: { errors: JSON.stringify(response.response.errors) },
      });
    }
  } catch (error) {
    logger.error(error, {
      offerId,
      domain: 'deleteFromFavorite',
    });

    throw error;
  }
}
